<template>
  <div class="product-accordion" :class="`product-accordion_${privacyTypeSlugs[content.item.publishedTo]}`" ref="product-accordion">
    <div class="product-accordion__inner">
      <b class="product-accordion__title">
        <LockIcon :published-to="content.item.publishedTo" />
        {{ title }}
      </b>
      <div class="product-accordion__col-holder" :class="`product-accordion__col-holder_${accordionClassName}`">
        <div class="product-accordion__col" v-if="isContentPresent">
          <div class="product-accordion__content" v-external-links-blank>
            <p v-if="longDescr.external" class="product-accordion__info" v-html="longDescr.external"></p>
            <p v-if="longDescr.internal" class="product-accordion__info internal-information" v-html="longDescr.internal"></p>
            <p v-if="shortDescr.external" class="product-accordion__info" v-html="shortDescr.external"></p>
            <p v-if="shortDescr.internal" class="product-accordion__info internal-information" v-html="shortDescr.internal"></p>
            <p v-if="description.internal" class="product-accordion__info internal-information" v-html="description.internal"></p>
            <p v-if="descr.external" class="product-accordion__info" v-html="descr.external"></p>
            <p v-if="descr.internal" class="product-accordion__info internal-information" v-html="descr.internal"></p>
            <p
              v-if="features.external || features.internal"
              class="product-accordion__info sub-heading"
              v-html="langJson[lang].features"
            ></p>
            <p v-if="features.external" class="product-accordion__info" v-html="features.external"></p>
            <p v-if="features.internal" class="product-accordion__info internal-information" v-html="features.internal"></p>
            <p
              v-if="standardFittings.external || standardFittings.internal"
              class="product-accordion__info sub-heading"
              v-html="langJson[lang].standardFittings"
            ></p>
            <p v-if="standardFittings.external" class="product-accordion__info" v-html="standardFittings.external"></p>
            <p v-if="standardFittings.internal" class="product-accordion__info internal-information" v-html="standardFittings.internal"></p>
            <p
              v-if="altFittings.external || altFittings.internal"
              class="product-accordion__info sub-heading"
              v-html="langJson[lang].alternativeFittings"
            ></p>
            <p v-if="altFittings.external" class="product-accordion__info" v-html="altFittings.external"></p>
            <p v-if="altFittings.internal" class="product-accordion__info internal-information" v-html="altFittings.internal"></p>
            <p
              v-if="calculation.external || calculation.internal"
              class="product-accordion__info sub-heading"
              v-html="langJson[lang].calculations"
            ></p>
            <p v-if="calculation.external" class="product-accordion__info" v-html="calculation.external"></p>
            <p v-if="calculation.internal" class="product-accordion__info internal-information" v-html="calculation.internal"></p>
            <p v-if="endUserDescr.external" class="product-accordion__info" v-html="endUserDescr.external"></p>
            <p v-if="endUserDescr.internal" class="product-accordion__info internal-information" v-html="endUserDescr.internal"></p>
            <p v-if="notaBene.external" class="product-accordion__note" v-html="notaBene.external"></p>
            <p v-if="notaBene?.internal" class="product-accordion__note" v-html="notaBene.internal"></p>
            <p v-if="erpCode" class="product-accordion__info internal-information" v-html="erpCode"></p>
            <p v-if="serviceInfo" class="product-accordion__info sub-heading" v-html="langJson[lang].serviceInformation"></p>
            <p v-if="serviceInfo" class="product-accordion__info service-information" v-html="serviceInfo"></p>
          </div>
        </div>
        <div class="product-accordion__col" v-if="isResourcesPresent">
          <div class="product-accordion__media-list">
            <div class="product-accordion__media-list-inner">
              <div
                v-for="(resource, index) in resourceGroups"
                class="product-accordion__media-item"
                :class="`product-accordion__media-item_${privacyTypeSlugs[resource.item.publishedTo]}`"
                :key="'resource_' + index"
              >
                <template v-if="content.item.productBlockType !== 'ProductCard'">
                  <div class="product-accordion__media-item-inner">
                    <LockIcon :published-to="resource.item.publishedTo" />
                    <div class="product-accordion__media-holder">
                      <div class="product-accordion__media-box">
                        <template v-if="resource.item.type === resourceTypes.VIDEO">
                          <div class="product-accordion__player" @click="play(index, $event)">
                            <span class="icon-player product-accordion__player-icon"></span>
                            <video width="250" height="250" @ended="onEnd">
                              <source :src="baseUrlMedia + resource.item.fileId + '/' + resource.item.fileName" type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </template>
                        <template v-else>
                          <img
                            :src="previewImagePath(resource.item)"
                            @error="handleImageError"
                            :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                            class="product-accordion__image"
                          />
                        </template>
                      </div>
                    </div>
                    <div class="product-accordion__media-content">
                      <b class="product-accordion__media-title">
                        {{ setProperFieldExternalFirst(resource.item, 'title') }}
                      </b>
                    </div>
                    <div class="product-accordion__media-bottom-bar">
                      <product-downloads :resource="resource"></product-downloads>
                      <div class="product-accordion__media-details" @click="handleOpenProductDetails(resource, $event)">
                        <div class="product-accordion__media-details-button">
                          {{ langJson[lang].details }}
                          <i class="icon-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="product-page-item__media-box">
                    <img
                      :src="previewImagePath(resource.item)"
                      @error="handleImageError"
                      :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                      class="product-page-item__image"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <product-accordion-items-list v-if="content.item.items && content.item.items.length" :items="content.item.items" />
      <div class="product-accordion__close-btn icon-cancel" @click="closeAccordion"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { handleImageError } from '~/utils/imageFallback';
  import stringMixins from '~/mixins/string.js';
  import resourceMixins from '~/mixins/resource.js';
  import { setProperFieldExternalFirst, setProperFieldExternal, setProperFieldInternal } from '@/utils/fieldGetters';
  import { privacyTypeSlugs, resourceTypes, resourceDisplayPriority } from '~/constants';

  interface ResourceFileItem {
    fileName: string;
    mimeType: string;
    fileId: string;
    publishedTo: number;
    extension: string;
    type?: string;
    external?: Record<string, string>;
    internal?: Record<string, string>;
    [key: string]: unknown;
  }

  interface ResourceGroup {
    item: ResourceFileItem;
    items: ResourceFileItem[];
  }

  interface WindowWithGtm extends Window {
    $gtm?: { pushEvent: (data: Record<string, unknown>) => void };
  }

  const emit = defineEmits(['close']);
  const props = defineProps({
    content: {
      type: Object,
      default: () => ({})
    }
  });

  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);

  // Mixins helpers
  const { getLengthEvery } = stringMixins.methods;
  const removeFileNameExtension = (x: string) => x.replace(/\.[^/.]+$/, '');
  const extractExtensionFromFileName = (x: string) => x.split('.').pop();
  const { getResourceType } = resourceMixins.methods;

  const imgRatio = '?width=300&height=300';
  const imgMaxSize = '&width=300&height=300';
  const filePreview = '/Preview?mimetype=image/jpg';

  function breakRefs(data: unknown) {
    return JSON.parse(JSON.stringify(data));
  }

  function prepareResources(resources: ResourceFileItem[]) {
    const map = new Map<string, ResourceGroup>();
    if (resources === null) {
      return map;
    }
    resources.forEach((item: ResourceFileItem) => {
      const resourceName = removeFileNameExtension(item.fileName);
      const extension = extractExtensionFromFileName(item.fileName) || '';
      const collection = map.get(resourceName);
      if (!collection) {
        map.set(resourceName, {
          item: { ...item, extension, type: getResourceType(item.mimeType, extension) },
          items: [{ ...item, extension }]
        });
      } else {
        if (resourceDisplayPriority.indexOf(extension) > resourceDisplayPriority.indexOf(collection.item.extension)) {
          collection.item = {
            ...item,
            extension,
            type: getResourceType(item.mimeType, extension)
          };
        }
        collection.items.push({ ...item, extension });
      }
    });
    return map;
  }
  const resources = ref(prepareResources(breakRefs(props.content.item?.resources)));
  const resourceGroups = computed(() => {
    try {
      const vals = resources.value && typeof resources.value.values === 'function' ? resources.value.values() : [];
      return Array.from(vals);
    } catch {
      return [];
    }
  });

  const title = computed(() => setProperFieldExternalFirst(props.content.item, 'title'));
  const shortDescr = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'shortDescr'),
    internal: setProperFieldInternal(props.content.item, 'shortDescr')
  }));
  const description = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'description'),
    internal: setProperFieldInternal(props.content.item, 'description')
  }));
  const descr = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'descr'),
    internal: setProperFieldInternal(props.content.item, 'descr')
  }));
  const longDescr = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'longDescr'),
    internal: setProperFieldInternal(props.content.item, 'longDescr')
  }));
  const altFittings = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'altFittings'),
    internal: setProperFieldInternal(props.content.item, 'altFittings')
  }));
  const standardFittings = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'standardFittings'),
    internal: setProperFieldInternal(props.content.item, 'standardFittings')
  }));
  const features = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'features'),
    internal: setProperFieldInternal(props.content.item, 'features')
  }));
  const calculation = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'calculation'),
    internal: setProperFieldInternal(props.content.item, 'calculation')
  }));
  const endUserDescr = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'endUserDescr'),
    internal: setProperFieldInternal(props.content.item, 'endUserDescr')
  }));
  const notaBene = computed(() => ({
    external: setProperFieldExternal(props.content.item, 'notaBene'),
    internal: setProperFieldInternal(props.content.item, 'notaBene')
  }));

  const erpCode = computed(() => {
    if (props.content.item.internal && props.content.item.external) {
      return props.content.item.erpCode ?? props.content.item.internal.erpCode ?? props.content.item.external.erpCode;
    } else {
      return props.content.item.erpCode;
    }
  });

  const serviceInfo = computed(() => {
    if (props.content.item.internal && props.content.item.external) {
      return props.content.item.serviceInfo ?? props.content.item.internal.serviceInfo ?? props.content.item.external.serviceInfo;
    } else {
      return props.content.item.serviceInfo;
    }
  });

  const isContentPresent = computed(
    () =>
      getLengthEvery(
        standardFittings.value.external,
        endUserDescr.value.external,
        description.value.external,
        altFittings.value.external,
        calculation.value.external,
        shortDescr.value.external,
        longDescr.value.external,
        features.value.external,
        notaBene.value.external,
        descr.value.external,
        shortDescr.value.internal,
        description.value.internal,
        descr.value.internal,
        longDescr.value.internal,
        altFittings.value.internal,
        standardFittings.value.internal,
        features.value.internal,
        calculation.value.internal,
        endUserDescr.value.internal,
        notaBene.value.internal
      ) > 0
  );

  const isResourcesPresent = computed(() => props.content.item.resources && props.content.item.resources.length > 0);
  const displayedResourcesCount = computed(() => resources.value.size);
  const accordionClassName = computed(() => {
    if (isResourcesPresent.value && isContentPresent.value) {
      switch (displayedResourcesCount.value) {
        case 1:
          return 'wide-text';
        case 2:
          return 'narrow-text';
        default:
          return 'block-text';
      }
    } else {
      return isContentPresent.value ? 'only-content' : 'only-resources';
    }
  });

  function previewImagePath(file: ResourceFileItem) {
    if (file.mimeType.includes('application')) {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + filePreview + imgMaxSize;
    } else {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + imgRatio;
    }
  }

  function closeAccordion() {
    emit('close');
  }

  function play(index: number, event: Event) {
    if (event.target) {
      const target = event.target as HTMLElement;
      const videoElement = target.childNodes[2] as HTMLVideoElement;
      if (videoElement && videoElement.paused) {
        target.classList.add('playing');
        videoElement.play();
      } else if (videoElement) {
        target.classList.remove('playing');
        videoElement.pause();
      }
    }
  }

  function onEnd(event: Event) {
    if (event.target) {
      const target = event.target as HTMLElement;
      if (target.parentNode) {
        (target.parentNode as HTMLElement).classList.remove('playing');
      }
    }
  }

  function onAccordionDataUpdateRemovePlaying() {
    const accordion = document.querySelector('.product-accordion');
    if (!accordion) return;
    const playingElements = accordion.getElementsByClassName('playing');
    for (let i = playingElements.length - 1; i > -1; i--) {
      playingElements[i].classList.remove('playing');
    }
  }

  function handleOpenProductDetails(resource: ResourceGroup, event: Event) {
    const productResourceTitle =
      resource.item.external && resource.item.external.title
        ? resource.item.external.title
        : resource.item.internal && resource.item.internal.title
          ? resource.item.internal.title
          : resource.item.fileName;
    if (window && (window as unknown as WindowWithGtm).$gtm) {
      (window as unknown as WindowWithGtm).$gtm?.pushEvent({
        productResourceTitle,
        event
      });
    }
    if (mainStore.openProductDetails) mainStore.openProductDetails(resource);
  }

  onUpdated(() => {
    onAccordionDataUpdateRemovePlaying();
  });
</script>
